import { createSelector } from 'reselect';

export const getComponentState = state => state.punchout;

export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getSession = createSelector(
    getComponentState,
    (state) => state.session
);
export const getHistory = createSelector(
    getComponentState,
    (state) => state.history
);
export const getEmail = createSelector(
    getComponentState,
    (state) => state.email
);
export const getLoging = createSelector(
    getComponentState,
    (state) => state.loging
);